import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getAgenciesDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
    agencies: [
    {
        fieldName: "Order Sequence",
        fieldValue: "field_agency_order_sequence",
        className: "col-span-6",
        type: "text",
        name: "field_agency_order_sequence",
        formType: "input",
        label: "Order Sequence",
        placeholder: "Enter Order Sequence",
        validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "field_agency_image",
      className: "col-span-6",
      type: "image",
      name: "field_agency_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: " Title",
      validation: { required: " Title is required" },
    },
    {
        fieldName: "Title (MS)",
        fieldValue: "field_agency_title_ms",
        className: "col-span-6",
        type: "text",
        name: "field_agency_title_ms",
        formType: "input",
        label: "Title",
        placeholder: " Title",
        validation: { required: " Title is required" },
      },  {
        fieldName: "Title (ZH)",
        fieldValue: "field_agency_title_zh",
        className: "col-span-6",
        type: "text",
        name: "field_agency_title_zh",
        formType: "input",
        label: "Title",
        placeholder: " Title",
        validation: { required: " Title is required" },
      },
    // {
    //     fieldName: "Description (EN)",
    //     fieldValue: "field_homecards_desc_en",
    //     className: "col-span-6",
    //     type: "text",
    //     name: "field_homecards_desc_en",
    //     formType: "richText",
    //     label: "Description (EN)",
    //     placeholder: "Enter Description (EN)",
    //     validation: { required: "Description (EN) is required" },
    //   },
    //   {
    //     fieldName: "Description (MS)",
    //     fieldValue: "field_homecards_desc_ms",
    //     className: "col-span-6",
    //     type: "text",
    //     name: "field_homecards_desc_ms",
    //     formType: "richText",
    //     label: "Description (MS)",
    //     placeholder: "Enter Description (MS)",
    //     // validation: { required: "Description (MS) is required" },
    //   },
    //   {
    //     fieldName: "Description (ZH)",
    //     fieldValue: "field_homecards_desc_zh",
    //     className: "col-span-6",
    //     type: "text",
    //     name: "field_homecards_desc_zh",
    //     formType: "richText",
    //     label: "Description (ZH)",
    //     placeholder: "Enter Description (ZH)",
    //     // validation: { required: "Description (ZH) is required" },
    //   },
    {
      fieldName: "Agency url (EN)",
      fieldValue: "field_agency_link_en",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_en",
      formType: "input",
      label: "Banner url (EN)",
      placeholder: "Enter Agency url (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Agency url (MS)",
      fieldValue: "field_agency_link_ms",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_ms",
      formType: "input",
      label: "Banner url (MS)",
      placeholder: "Enter Agency url (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Agency url (ZH)",
      fieldValue: "field_agency_link_zh",
      className: "col-span-6",
      type: "text",
      name: "field_agency_link_zh",
      formType: "input",
      label: "Banner url (ZH)",
      placeholder: "Enter Agency url (ZH)",
      validation: { required: "Banner url (ZH) is required" },
    },
    {
        fieldName: "Agency Page (EN)",
        fieldValue: "field_agency_page_en",
        className: "col-span-6",
        type: "text",
        name: "field_agency_page_en",
        formType: "input",
        label: "Agency Page (EN)",
        placeholder: "Enter Agency Page (EN)",
        validation: { required: "Agency Page (EN) is required" },
      }, {
        fieldName: "Agency Page (MS)",
        fieldValue: "field_agency_page_ms",
        className: "col-span-6",
        type: "text",
        name: "field_agency_page_ms",
        formType: "input",
        label: "Agency (ZH)",
        placeholder: "Enter Agency Page (MS)",
        validation: { required: "Agency (MS) is required" },
      }, {
        fieldName: "Agency Page (ZH)",
        fieldValue: "field_agency_page_zh",
        className: "col-span-6",
        type: "text",
        name: "field_agency_page_zh",
        formType: "input",
        label: "Agency Page (ZH)",
        placeholder: "Enter Agency url (ZH)",
        validation: { required: "Agency Page (ZH) is required" },
      },
   
  ],
};
